import { useQuery } from "@tanstack/react-query";
import MetricsAPI from "@/api/Metrics/Metrics.js";
import convertBytesToSize from "@/utils/convertBytesToSize";
import moment from "moment";
import CoreWidget from "./CoreWidget";
import { timezone } from "@/utils/timezoneResolver";

const DataCollectedWidget = () => {
  const metrics = [
    {
      metric: "dataCollected",
      args: [
        timezone,
        moment().startOf("month").format("YYYY-MM-DD"),
        moment().format("YYYY-MM-DD"),
      ],
    },
    {
      metric: "dataCollected",
      args: [
        timezone,
        moment().subtract(1, "month").startOf("month").format("YYYY-MM-DD"),
        moment().subtract(1, "month").endOf("month").format("YYYY-MM-DD"),
      ],
    },
  ];

  const { data } = useQuery({
    queryKey: ["metrics", { metrics }],
    queryFn: () => MetricsAPI.getMetrics({ metrics }),
  });

  if (!data) return null;
  const dataCollectedThisMonth = data?.data?.[0]?.dataCollected || {};
  const dataCollectedLastMonth = data?.data?.[1]?.dataCollected || {};

  // calculate percentage change
  let percentageChange: number | string =
    ((dataCollectedThisMonth.total_size_bytes -
      dataCollectedLastMonth.total_size_bytes) /
      dataCollectedLastMonth.total_size_bytes) *
    100;

  percentageChange = percentageChange.toFixed(2);

  const dataCollectedItems = [
    {
      label: "Active",
      value: dataCollectedThisMonth?.active_count || 0,
    },
    {
      label: "Deleted",
      value: dataCollectedThisMonth?.delete_count || 0,
    },
    {
      label: "Total Active Data",
      value: convertBytesToSize(dataCollectedThisMonth.active_size_bytes),
    },
    {
      label: "Total Data",
      value: convertBytesToSize(dataCollectedThisMonth.total_size_bytes),
    },
  ];

  return (
    <>
      <CoreWidget
        statTitle="Data Collected (This Month)"
        statValue={convertBytesToSize(dataCollectedThisMonth.total_size_bytes)}
        percentageChange={percentageChange}
        detailItems={dataCollectedItems}
      />
    </>
  );
};

export default DataCollectedWidget;
